<ion-badge class="badge" [color]="color">
  {{ orderStepToString(orderNextStep) }}
</ion-badge>
